module.exports = __webpack_public_path__ + "img/emw_1.a15c68d1.png";